import React from 'react';
import Logo from "../assets/Deeze/Logo.png";
import { FaGithub, FaGoogle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Login = () => {
  return (
    <div className='flex flex-row h-screen'>
      {/* Left Section */}
      <div className='h-screen lg:w-2/5 flex flex-col relative bg-[#172554] justify-center'>
        <Link to='/home'><img className='lg:w-1/5 w-28 m-6 absolute top-0' src={Logo} alt="logo"/></Link>
        <div className='rounded-xl justify-center gap-5 mt-20 flex flex-col p-10'>
          <h1 className='poppins-extrabold text-xl lg:text-4xl text-white'>Welcome back!</h1>
          <p className='poppins-regular text-sm text-white'>Log in with your email and password or sign in using your GitHub or Google account.</p>
          <div className='flex flex-col justify-center gap-1'>
            <label htmlFor='email' className='text-white poppins-regular'>Email:</label>
            <input id='email' type='email' placeholder='Email' className='outline-none rounded-sm p-4 lg:w-4/5 bg-[#0E1D4E] text-white'/>

            <label htmlFor='password' className='text-white poppins-regular mt-5'>Password:</label>
            <input id='password' type='password' placeholder='Password' className='outline-none rounded-sm p-4 lg:w-4/5 bg-[#0E1D4E] text-white'/>
            <button className='bg-[#29408b] hover:bg-[#3c54a3] p-2 rounded-sm lg:w-4/5 text-white text-center poppins-bold my-5'>Login</button>
            <div className='flex flex-col items-center lg:w-4/5'>
              <p className='text-center text-white poppins-regular'>OR</p>
              <div className="flex justify-center py-5 gap-4">
                {/* GitHub Sign In Button */}
                <button className="bg-black text-white rounded-md p-2 flex items-center">
                  <FaGithub className="lg:mr-2"/>
                  <p className='lg:block hidden'>Sign in with GitHub</p>
                </button>
                {/* Google Sign In Button */}
                <button className="bg-red-600 text-white rounded-md p-2 flex items-center">
                  <FaGoogle className="lg:mr-2"/>
                  <p className='lg:block hidden'>Sign in with Google</p>
                </button>
              </div>
              <Link to='/signup'><p className='text-center text-white'>Create an account</p></Link>
            </div>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className='bg-black   h-screen hidden lg:block lg:w-3/5' style={{backgroundImage: 'url(https://img.freepik.com/free-photo/close-up-young-business-person-doing-internship_23-2149305371.jpg)', backgroundSize: 'cover'}}></div>
    </div>
  );
};

export default Login;
